// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as Schema$LumiStore from "lumi-store/lib/es6/src/Schema.res.js";

let jsonCodec = Jzon.object2(param => [
  param.email,
  param.name
], param => ({
  TAG: "Ok",
  _0: {
    email: param[0],
    name: param[1]
  }
}), Jzon.field("email", Jzon.nullable(Jzon.string)), Jzon.field("name", Jzon.string));

function documentName(param) {
  return param.name;
}

let Schema = Schema$LumiStore.Make({
  documentName: documentName,
  tag: "account",
  jsonCodec: jsonCodec,
  icon: "user",
  readOnly: false
});

export {
  jsonCodec,
  Schema,
}
/* jsonCodec Not a pure module */
